import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { DOCUMENT, Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class SqlService {
  UserLoggedIn = false;
  public UserLevel = '';
  Username = '';

  //Link = 'http://localhost/assets/php/';
  Link = "http://10.10.10.2/xdt/assets/php/";

  constructor(private http: HttpClient, private router: Router, private location: Location, @Inject(DOCUMENT) private document: Document) {
   
    if(this.document.location.hostname.includes('admin.pactel.co.za')){
      this.Link = "https://admin.pactel.co.za/xdt/assets/php/";
    }else if(this.document.location.hostname.includes('localhost')){
      this.Link = 'https://admin.pactel.co.za/xdt/assets/php/';
    }else{
      this.Link = 'http://10.10.10.2/xdt/assets/php/';
    }
  }  

  getUsername() {
    let tempUsername = localStorage.getItem('Username');
    if (tempUsername != null && tempUsername.length >= 5) {
      this.Username = tempUsername;
    } else {
      this.Username = '';
    }
    return this.Username;
  }

  isUserLoggedIn(): boolean {
    if (localStorage.getItem('UserLoggedIn') == 'true') {
      this.UserLoggedIn = true;
    } else {
      this.UserLoggedIn = false;
    }

    return this.UserLoggedIn;
  }

  getUserLevel(): string {
    if (localStorage.getItem('UserLevel')?.includes('Admin')) {
      this.UserLevel = 'Admin';
    } else if (localStorage.getItem('UserLevel')?.includes('Manager')) {
      this.UserLevel = 'Manager';
    } else {
      this.UserLevel = 'User';
    }
    return this.UserLevel;
  }

  LogUserIn(Username: string, Password: string) {
    return this.http
      .get(
        this.Link + 'login.php?username=' + Username + '&password=' + Password
      )
      .pipe(catchError(this.handleError));
  }

  DidUserLogInSuccessfully(
    Rights: string,
    Success: Boolean,
    UsersUsername: string
  ) {
    if (Success == true) {
      localStorage.setItem('UserLoggedIn', 'true');
      localStorage.setItem('UserLevel', '1£' + Rights);
      localStorage.setItem('Username', UsersUsername);

      this.UserLoggedIn = true;
      this.UserLevel = Rights;
      this.Username = UsersUsername;
    } else {
      localStorage.setItem('UserLoggedIn', 'false');
      localStorage.setItem('UserLevel', '');
      localStorage.setItem('Username', '');

      this.UserLoggedIn = false;
      this.UserLevel = '';
      this.Username = '';
    }
  }

  Logout() {
    this.UserLoggedIn = false;
    this.UserLevel = '';
    localStorage.setItem('UserLoggedIn', 'false');
    localStorage.setItem('UserLevel', '');
    localStorage.setItem('Username', '');
    this.router.navigate(['']);
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    console.log(errorMessage);
    window.alert(
      'Something went wrong, please try again. If this continues please contact the I.T Department'
    );
    return throwError(
      'Something went wrong, please try again. If this continues please contact the I.T Department'
    );
    //return throwError(errorMessage);
  }

  getAllProvinces() {
    return this.http
      .get(this.Link + 'getProvinces.php')
      .pipe(catchError(this.handleError));
  }

  getAreaPerProvince(Province: string) {
    return this.http
      .get(this.Link + 'getAreaPerProvinces.php?Province=' + Province)
      .pipe(catchError(this.handleError));
  }

  GetAllClients() {
    return this.http
      .get(this.Link + 'getAllClients.php')
      .pipe(catchError(this.handleError));
  }

  GetAllClientsForView(frmData: FormData) {
    return this.http.post(this.Link + 'getAllClientsForView.php', frmData);
  }
  GetSimularClientsForView(frmData: FormData) {
    return this.http.post(this.Link + 'getSimularClient.php', frmData);
  }

  AddClient(Name: string, Province: string, Area: string, ClientCellNumber:string) {
    var formData = new FormData(); // Currently empty

    formData.set('Name', Name);
    formData.set('Province', Province);
    formData.set('Area', Area);
    formData.set('ClientCellNumber', ClientCellNumber);
    return this.http.post(this.Link + 'addClient.php', formData);
  }

  AddMultipleClients(formData: FormData) {
    return this.http.post(this.Link + 'addMultipleClients.php', formData);
  }

  DeleteClient(Name: string) {
    return this.http
      .get(this.Link + 'deleteClient.php?Name=' + Name)
      .pipe(catchError(this.handleError));
  }

  EditClient(
    OldName: string,
    Name: string,
    Province: string,
    Area: string,
    OldClientArea: string,
    ClientCellNumber: string
  ) {
    var formData = new FormData(); // Currently empty

    formData.set('OldClientName', OldName);
    formData.set('OldClientArea', OldClientArea);
    formData.set('ClientName', Name);
    formData.set('Province', Province);
    formData.set('Area', Area);
    formData.set('ClientCellNumber', ClientCellNumber);

    return this.http.post(this.Link + 'editClient.php', formData);
  }

  GetSpecificClients(ClientName: string, ClientArea: string) {
    var formData = new FormData(); // Currently empty

    formData.set('ClientName', ClientName);
    formData.set('ClientArea', ClientArea);

    return this.http.post(this.Link + 'getSpecificClient.php', formData);
  }

  AddArea(Area: string, Province: string) {
    return this.http
      .get(this.Link + 'addArea.php?Area=' + Area + '&Province=' + Province)
      .pipe(catchError(this.handleError));
  }

  AddAgent(
    Name: string,
    Surname: string,
    CellNo: string,
    Code: string,
    DistributorID: string,
    AreaUnique: string
  ) {
    var formData = new FormData(); // Currently empty

    formData.set('Name', Name);
    formData.set('Surname', Surname);
    formData.set('CellNo', CellNo);
    formData.set('uCode', Code);
    formData.set('DistributorID', DistributorID);
    formData.set('AreaUnique', AreaUnique);

    return this.http.post(this.Link + 'addAgent.php', formData);
  }

  getAreasWithIdPerProvince(province: string) {
    return this.http.get(this.Link + 'getAreasWithIdPerProvince.php?Province=' + encodeURIComponent(province)).pipe(catchError(this.handleError));
  }

  getAllAgents() {
    return this.http
      .get(this.Link + 'getAllAgents.php')
      .pipe(catchError(this.handleError));
  }

  GetSpecificAgent(AgentName: string) {
    var formData = new FormData(); // Currently empty
    formData.set('ID', AgentName);
    return this.http.post(this.Link + 'getSpecificAgent.php', formData);
  }

  DeleteAgent(ID: string) {
    var formData = new FormData(); // Currently empty

    formData.set('ID', ID);
    return this.http.post(this.Link + 'deleteAgent.php', formData);
  }

  EditAgentName(formData: FormData) {
    return this.http.post(this.Link + 'editAgent.php', formData);
  }

  getAllAreas() {
    return this.http
      .get(this.Link + 'getAllAreas.php')
      .pipe(catchError(this.handleError));
  }

  GetSpecificArea(AreaName: string) {
    var formData = new FormData(); // Currently empty
    formData.set('AreaName', AreaName);
    return this.http.post(this.Link + 'getSpecificArea.php', formData);
  }

  DeleteArea(Name: string) {
    var formData = new FormData(); // Currently empty

    formData.set('AreaName', Name);
    return this.http.post(this.Link + 'deleteArea.php', formData);
  }

  EditArea(OldName: string, Name: string, Province: string) {
    var formData = new FormData(); // Currently empty

    formData.set('OldAreaName', OldName);
    formData.set('AreaName', Name);
    formData.set('Province', Province);

    return this.http.post(this.Link + 'editArea.php', formData);
  }

  AddDistrubutor(DistributorsName: string, Province: string, Active: string) {
    return this.http
      .get(
        this.Link +
        'addDistributor.php?DistributorsName=' +
        DistributorsName +
        '&Province=' +
        Province +
        '&Active=' +
        Active
      )
      .pipe(catchError(this.handleError));
  }

  getAllDistrubutor() {
    return this.http
      .get(this.Link + 'getAllDistributors.php')
      .pipe(catchError(this.handleError));
  }

  DeleteDistrubutor(Name: string) {
    var formData = new FormData(); // Currently empty

    formData.set('DistributorName', Name);
    return this.http.post(this.Link + 'deleteDistrubutor.php', formData);
  }

  EditDistrubutor(
    OldName: string,
    Name: string,
    Province: string,
    Active: string
  ) {
    var formData = new FormData(); // Currently empty

    formData.set('OldDistributorName', OldName);
    formData.set('DistributorName', Name);
    formData.set('Province', Province);
    formData.set('Active', Active);

    return this.http.post(this.Link + 'editDistrubutor.php', formData);
  }

  GetSpecificDistrubutor(Name: string) {
    var formData = new FormData(); // Currently empty
    formData.set('DistributorName', Name);
    return this.http.post(this.Link + 'getSpecificDistrubutor.php', formData);
  }

  getAllProviders() {
    return this.http
      .get(this.Link + 'getAllProviders.php')
      .pipe(catchError(this.handleError));
  }

  GetSpecificProvider(Name: string) {
    var formData = new FormData(); // Currently empty
    formData.set('ProvidersName', Name);
    return this.http.post(this.Link + 'getSpecificProvider.php', formData);
  }

  AddProvider(Provider: string, DirectBoxSize: string, DirectBatchSize: string, InDirectBoxSize: string, InDirectBatchSize: string) {
    var formData = new FormData(); // Currently empty

    formData.set('Provider', Provider);
    formData.set('DirectBoxSize', DirectBoxSize);
    formData.set('DirectBatchSize', DirectBatchSize);
    formData.set('InDirectBoxSize', InDirectBoxSize);
    formData.set('InDirectBatchSize', InDirectBatchSize);

    return this.http.post(this.Link + 'addProvider.php', formData);
  }

  DeleteProvider(Name: string) {
    var formData = new FormData(); // Currently empty

    formData.set('ProvidersName', Name);
    return this.http.post(this.Link + 'deleteProvider.php', formData);
  }

  EditProvider(
    OldProvider: string,
    Provider: string,
    DirectBoxSize: string,
    DirectBatchSize: string,
    InDirectBoxSize: string,
    InDirectBatchSize: string
  ) {
    var formData = new FormData(); // Currently empty

    formData.set('OldProvider', OldProvider);
    formData.set('Provider', Provider);
    formData.set('DirectBoxSize', DirectBoxSize);
    formData.set('DirectBatchSize', DirectBatchSize);
    formData.set('InDirectBoxSize', InDirectBoxSize);
    formData.set('InDirectBatchSize', InDirectBatchSize);

    return this.http.post(this.Link + 'editProvider.php', formData);
  }

  GetAllBranches() {
    return this.http
      .get(this.Link + 'getAllBranches.php')
      .pipe(catchError(this.handleError));
  }

  AddBranch(Name: string) {
    return this.http
      .get(this.Link + 'addBranch.php?Name=' + Name)
      .pipe(catchError(this.handleError));
  }

  DeleteBranches(Name: string) {
    var formData = new FormData(); // Currently empty

    formData.set('Name', Name);
    return this.http.post(this.Link + 'deleteBranch.php', formData);
  }

  EditBranches(OldName: string, Name: string) {
    var formData = new FormData(); // Currently empty

    formData.set('OldName', OldName);
    formData.set('Name', Name);

    return this.http.post(this.Link + 'editBranch.php', formData);
  }

  getAllUsers() {
    return this.http
      .get(this.Link + 'getAllUsers.php')
      .pipe(catchError(this.handleError));
  }

  GetSpecificUser(Name: string) {
    var formData = new FormData(); // Currently empty
    formData.set('Username', Name);
    return this.http.post(this.Link + 'getSpecificUser.php', formData);
  }

  AddUser(Username: string, Password: string, Rights: string) {
    var formData = new FormData(); // Currently empty
    formData.set('Username', Username);
    formData.set('Password', Password);
    formData.set('Rights', Rights);
    return this.http.post(this.Link + 'addUser.php', formData);
  }

  DeleteUser(Name: string) {
    var formData = new FormData(); // Currently empty

    formData.set('Username', Name);
    return this.http.post(this.Link + 'deleteUser.php', formData);
  }

  EditUser(
    OldUsername: string,
    Username: string,
    Password: string,
    Rights: string
  ) {
    var formData = new FormData(); // Currently empty

    formData.set('OldUsername', OldUsername);
    formData.set('Username', Username);
    formData.set('Password', Password);
    formData.set('Rights', Rights);

    return this.http.post(this.Link + 'editUser.php', formData);
  }

  AddNewBox(formData: FormData) {
    return this.http.post(this.Link + 'addNewBox.php', formData);
  }

  EmailAdditionOfBoxDetails(formData: FormData) {
    return this.http.post(this.Link + 'sendEmailForSImportingResults.php', formData);
  }

  SelectSuperviser(formData: FormData) {
    return this.http.post(this.Link + 'SelectSuperviser.php', formData);
  }

  DeleteBox(formData: FormData) {
    return this.http.post(this.Link + 'deleteBox.php', formData);
  }

  TransferBranch(BoxNumber: string, Branch: string) {
    var formData = new FormData(); // Currently empty

    formData.set('BoxNumber', BoxNumber);
    formData.set('Branch', Branch);

    return this.http.post(this.Link + 'TransferBranch.php', formData);
  }

  GetBoxDetails(BoxNumber: string) {
    var formData = new FormData(); // Currently empty

    formData.set('BoxNumber', BoxNumber);

    return this.http.post(this.Link + 'getBoxDetails.php', formData);
  }

  AddNewBatch(formData: FormData) {
    return this.http.post(this.Link + 'addNewBatch.php', formData);
  }

  FinanilizeAllBatches(formData: FormData) {
    return this.http.post(this.Link + 'finanilizeAllBatches.php', formData);
  }

  ClearBoxBatches(formData: FormData) {
    return this.http.post(this.Link + 'clearBoxBatches.php', formData);
  }

  AllocateDistributor(formData: FormData) {
    return this.http.post(this.Link + 'allocateDistributor.php', formData);
  }

  getClientsPerProvince(formData: FormData) {
    return this.http.post(this.Link + 'getClientsPerProvince.php', formData);
  }

  FinishBox(formData: FormData) {
    return this.http.post(this.Link + 'FinishBox.php', formData);
  }

  getAllBoxes(formData: FormData) {
    return this.http.post(this.Link + 'getAllBoxes.php', formData);
  }

  ExportAllBoxes(formData: FormData) {
    return this.http.post(this.Link + 'exportData.php', formData);
  }

  getAllDirectBoxes(formData: FormData) {
    return this.http.post(this.Link + 'getAllDirectBoxes.php', formData);
  }

  getAuditLog(formData: FormData) {
    return this.http.post(this.Link + 'getAuditLog.php', formData);
  }

  getAllBoxesNames(formData: FormData) {
    return this.http.post(this.Link + 'getAllBoxNames.php', formData);
  }

  getAllBrickesNames(formData: FormData) {
    return this.http.post(this.Link + 'getAllBrickNames.php', formData);
  }

  SelectAgent(formData: FormData) {
    return this.http.post(this.Link + 'SelectAgent.php', formData);
  }

  ExportAllDirectBoxes(formData: FormData) {
    this.http.post(this.Link + 'exportDirectData.php', formData);
  }

  //New condesed calls
  getTopBoxesNames(formData: FormData) {
    return this.http.post(this.Link + 'getTopBoxesNames.php', formData);
  }
  getTopBrickesNames(formData: FormData) {
    return this.http.post(this.Link + 'getTopBrickesNames.php', formData);
  }

  getTopBoxesNamesForSelectingAgentScreen(formData: FormData) {
    return this.http.post(this.Link + 'getTopBoxesNamesForSelectingAgentScreen.php', formData);
  }

  getAdminDashboardFirstTable() {
    return this.http.get(this.Link + 'getAdminDashboardFirstTable.php').pipe(catchError(this.handleError));
  }

  getAdminDashboardSecondTable(provider: string, type: string) {
    return this.http.get(this.Link + 'getAdminDashboardSecondTable.php?provider=' + encodeURIComponent(provider) + '&type=' + encodeURIComponent(type)).pipe(catchError(this.handleError));
  }

  getAppReports(filterType: string, searchTerm: string, supervisor: string = '') {
    let params = new HttpParams().set('filterType', filterType).set('searchTerm', searchTerm);
    if (supervisor != null && supervisor !== '') {
      params = params.set('supervisor', supervisor);
    }
    return this.http.get(this.Link + 'getAppReports.php', { params }).pipe(catchError(this.handleError));
  }

  exportAppReports(filterType: string, searchTerm: string, supervisor: string = '') {
    // Returns a download URL (browser will handle file download)
    let url = this.Link + 'exportAppReports.php?filterType=' + encodeURIComponent(filterType) + '&searchTerm=' + encodeURIComponent(searchTerm);
    if (supervisor != null && supervisor !== '') {
      url += '&supervisor=' + encodeURIComponent(supervisor);
    }
    return url;
  }
}
